/**
 * WHO / IAP growth chart reference data.
 * Raw data: { Month, p3, p10, p25, p50, p75, p90, p97 }.
 * Ages for chart = Month / 12 (years). Curves = 7 percentiles, no calculation.
 */

const PERCENTILE_LABELS_7 = ['3rd', '10th', '25th', '50th', '75th', '90th', '97th'];
const PERCENTILE_LABELS_4 = ['3rd', '10th', '50th', '97th'];
const PERCENTILE_LABELS_HC_7 = ['3rd', '10th', '25th', '50th', '75th', '90th', '97th'];
// WHO percentile set for 0-5 weight charts (extreme outer lines approximate the +/- 3 SD bounds)
const PERCENTILE_LABELS_5_WHO = ['0.1st', '3rd', '50th', '97th', '99.9th'];

function buildFromRawTable5WHO(raw) {
  const ages = raw.map(r => r.Month / 12);
  const pKeys = ['P01', 'P3', 'P50', 'P97', 'P999'];
  const curves = PERCENTILE_LABELS_5_WHO.map((label, i) => ({
    label,
    value: raw.map(r => r[pKeys[i]])
  }));
  return { ages, curves };
}

// Ages 0-5 only (61 points) for BMI and Head Circumference
const AGE_0_5_YEARS = Array.from({ length: 61 }, (_, i) => i / 12);

// Helper: build { ages, curves } from raw table (Month, p3, p10, p25, p50, p75, p90, p97)
function buildFromRawTable(raw, labels = PERCENTILE_LABELS_7) {
  const ages = raw.map(r => r.Month / 12);
  const pKeys = ['p3', 'p10', 'p25', 'p50', 'p75', 'p90', 'p97'];
  const curves = labels.map((label, i) => ({
    label,
    value: raw.map(r => r[pKeys[i]])
  }));
  return { ages, curves };
}

// ========== Girls Height 5-18 years (IAP 2015 Indian Pediatrics, 7 percentile lines, every 6 months) ==========
const GIRLS_HEIGHT_5_18_RAW = [
  { Month: 60, p3: 97.2, p10: 100.5, p25: 103.9, p50: 107.5, p75: 111.3, p90: 115.2, p97: 119.3 },
  { Month: 66, p3: 99.8, p10: 103.2, p25: 106.8, p50: 110.5, p75: 114.4, p90: 118.3, p97: 122.5 },
  { Month: 72, p3: 102.3, p10: 106.0, p25: 109.7, p50: 113.5, p75: 117.4, p90: 121.5, p97: 125.6 },
  { Month: 78, p3: 104.9, p10: 108.7, p25: 112.5, p50: 116.5, p75: 120.5, p90: 124.6, p97: 128.7 },
  { Month: 84, p3: 107.4, p10: 111.4, p25: 115.4, p50: 119.4, p75: 123.5, p90: 127.7, p97: 131.9 },
  { Month: 90, p3: 110.0, p10: 114.1, p25: 118.2, p50: 122.4, p75: 126.6, p90: 130.8, p97: 135.0 },
  { Month: 96, p3: 112.6, p10: 116.8, p25: 121.1, p50: 125.4, p75: 129.6, p90: 133.9, p97: 138.1 },
  { Month: 102, p3: 115.2, p10: 119.6, p25: 124.0, p50: 128.4, p75: 132.7, p90: 137.0, p97: 141.3 },
  { Month: 108, p3: 117.8, p10: 122.4, p25: 126.9, p50: 131.4, p75: 135.8, p90: 140.2, p97: 144.5 },
  { Month: 114, p3: 120.5, p10: 125.2, p25: 129.9, p50: 134.4, p75: 138.9, p90: 143.3, p97: 147.6 },
  { Month: 120, p3: 123.3, p10: 128.1, p25: 132.8, p50: 137.4, p75: 142.0, p90: 146.4, p97: 150.8 },
  { Month: 126, p3: 126.1, p10: 130.9, p25: 135.7, p50: 140.4, p75: 145.0, p90: 149.5, p97: 153.9 },
  { Month: 132, p3: 128.8, p10: 133.7, p25: 138.6, p50: 143.3, p75: 147.9, p90: 152.4, p97: 156.8 },
  { Month: 138, p3: 131.5, p10: 136.4, p25: 141.2, p50: 145.9, p75: 150.6, p90: 155.1, p97: 159.6 },
  { Month: 144, p3: 134.0, p10: 138.9, p25: 143.7, p50: 148.4, p75: 153.0, p90: 157.5, p97: 162.0 },
  { Month: 150, p3: 136.3, p10: 141.1, p25: 145.8, p50: 150.5, p75: 155.1, p90: 159.6, p97: 164.1 },
  { Month: 156, p3: 138.2, p10: 142.9, p25: 147.6, p50: 152.2, p75: 156.8, p90: 161.3, p97: 165.9 },
  { Month: 162, p3: 139.9, p10: 144.5, p25: 149.1, p50: 153.6, p75: 158.2, p90: 162.7, p97: 167.2 },
  { Month: 168, p3: 141.3, p10: 145.8, p25: 150.2, p50: 154.7, p75: 159.2, p90: 163.7, p97: 168.2 },
  { Month: 174, p3: 142.4, p10: 146.8, p25: 151.1, p50: 155.5, p75: 160.0, p90: 164.5, p97: 169.0 },
  { Month: 180, p3: 143.3, p10: 147.5, p25: 151.8, p50: 156.1, p75: 160.5, p90: 165.0, p97: 169.5 },
  { Month: 186, p3: 144.1, p10: 148.1, p25: 152.3, p50: 156.6, p75: 160.9, p90: 165.3, p97: 169.8 },
  { Month: 192, p3: 144.7, p10: 148.6, p25: 152.7, p50: 156.9, p75: 161.2, p90: 165.6, p97: 170.1 },
  { Month: 198, p3: 145.2, p10: 149.1, p25: 153.1, p50: 157.2, p75: 161.4, p90: 165.7, p97: 170.2 },
  { Month: 204, p3: 145.7, p10: 149.5, p25: 153.4, p50: 157.4, p75: 161.6, p90: 165.9, p97: 170.4 },
  { Month: 210, p3: 146.2, p10: 149.8, p25: 153.6, p50: 157.6, p75: 161.7, p90: 166.0, p97: 170.5 },
  { Month: 216, p3: 146.6, p10: 150.2, p25: 153.9, p50: 157.8, p75: 161.9, p90: 166.1, p97: 170.6 }
];

// ========== Boys Height 5-18 years (IAP 2015 Indian Pediatrics, 7 percentile lines, every 6 months) ==========
const BOYS_HEIGHT_5_18_RAW = [
  { Month: 60, p3: 99.0, p10: 102.3, p25: 105.6, p50: 108.9, p75: 112.4, p90: 115.9, p97: 119.4 },
  { Month: 66, p3: 101.6, p10: 105.0, p25: 108.4, p50: 111.9, p75: 115.4, p90: 119.0, p97: 122.7 },
  { Month: 72, p3: 104.2, p10: 107.7, p25: 111.2, p50: 114.8, p75: 118.5, p90: 122.2, p97: 126.0 },
  { Month: 78, p3: 106.8, p10: 110.4, p25: 114.0, p50: 117.8, p75: 121.6, p90: 125.4, p97: 129.3 },
  { Month: 84, p3: 109.3, p10: 113.0, p25: 116.8, p50: 120.7, p75: 124.6, p90: 128.6, p97: 132.6 },
  { Month: 90, p3: 111.8, p10: 115.7, p25: 119.6, p50: 123.5, p75: 127.6, p90: 131.7, p97: 135.9 },
  { Month: 96, p3: 114.3, p10: 118.2, p25: 122.3, p50: 126.4, p75: 130.5, p90: 134.8, p97: 139.1 },
  { Month: 102, p3: 116.7, p10: 120.8, p25: 124.9, p50: 129.1, p75: 133.4, p90: 137.8, p97: 142.2 },
  { Month: 108, p3: 119.0, p10: 123.2, p25: 127.5, p50: 131.8, p75: 136.3, p90: 140.7, p97: 145.3 },
  { Month: 114, p3: 121.3, p10: 125.6, p25: 130.0, p50: 134.5, p75: 139.1, p90: 143.7, p97: 148.3 },
  { Month: 120, p3: 123.6, p10: 128.1, p25: 132.6, p50: 137.2, p75: 141.9, p90: 146.6, p97: 151.4 },
  { Month: 126, p3: 125.9, p10: 130.5, p25: 135.2, p50: 139.9, p75: 144.7, p90: 149.5, p97: 154.4 },
  { Month: 132, p3: 128.2, p10: 133.0, p25: 137.8, p50: 142.7, p75: 147.6, p90: 152.5, p97: 157.5 },
  { Month: 138, p3: 130.7, p10: 135.6, p25: 140.6, p50: 145.5, p75: 150.5, p90: 155.6, p97: 160.6 },
  { Month: 144, p3: 133.2, p10: 138.3, p25: 143.3, p50: 148.4, p75: 153.5, p90: 158.6, p97: 163.7 },
  { Month: 150, p3: 135.7, p10: 141.0, p25: 146.2, p50: 151.4, p75: 156.5, p90: 161.7, p97: 166.8 },
  { Month: 156, p3: 138.3, p10: 143.7, p25: 149.0, p50: 154.3, p75: 159.5, p90: 164.7, p97: 169.9 },
  { Month: 162, p3: 140.9, p10: 146.4, p25: 151.8, p50: 157.2, p75: 162.4, p90: 167.6, p97: 172.7 },
  { Month: 168, p3: 143.4, p10: 149.0, p25: 154.5, p50: 159.9, p75: 165.1, p90: 170.3, p97: 175.4 },
  { Month: 174, p3: 145.8, p10: 151.5, p25: 157.0, p50: 162.3, p75: 167.6, p90: 172.7, p97: 177.7 },
  { Month: 180, p3: 148.0, p10: 153.7, p25: 159.2, p50: 164.5, p75: 169.7, p90: 174.8, p97: 179.7 },
  { Month: 186, p3: 150.0, p10: 155.7, p25: 161.2, p50: 166.5, p75: 171.6, p90: 176.5, p97: 181.4 },
  { Month: 192, p3: 151.8, p10: 157.4, p25: 162.9, p50: 168.1, p75: 173.1, p90: 178.0, p97: 182.7 },
  { Month: 198, p3: 153.4, p10: 159.1, p25: 164.5, p50: 169.6, p75: 174.5, p90: 179.3, p97: 183.8 },
  { Month: 204, p3: 155.0, p10: 160.6, p25: 165.9, p50: 171.0, p75: 175.8, p90: 180.4, p97: 184.8 },
  { Month: 210, p3: 156.6, p10: 162.1, p25: 167.3, p50: 172.3, p75: 177.0, p90: 181.5, p97: 185.8 },
  { Month: 216, p3: 158.1, p10: 163.6, p25: 168.7, p50: 173.6, p75: 178.2, p90: 182.5, p97: 186.7 }
];

// ========== Boys Height 0-5 years (WHO Length/Height-for-age, 5 percentile lines, sampled monthly) ==========
const BOYS_HEIGHT_0_5_RAW = [
  { Month: 0, P01: 44.034, P3: 46.324, P50: 49.884, P97: 53.445, P999: 55.734 },
  { Month: 1, P01: 48.652, P3: 51.005, P50: 54.665, P97: 58.324, P999: 60.677 },
  { Month: 2, P01: 52.257, P3: 54.676, P50: 58.438, P97: 62.201, P999: 64.62 },
  { Month: 3, P01: 55.085, P3: 57.557, P50: 61.401, P97: 65.246, P999: 67.718 },
  { Month: 4, P01: 57.472, P3: 59.989, P50: 63.904, P97: 67.819, P999: 70.336 },
  { Month: 5, P01: 59.367, P3: 61.921, P50: 65.891, P97: 69.862, P999: 72.415 },
  { Month: 6, P01: 61.028, P3: 63.617, P50: 67.644, P97: 71.67, P999: 74.259 },
  { Month: 7, P01: 62.453, P3: 65.078, P50: 69.162, P97: 73.245, P999: 75.87 },
  { Month: 8, P01: 63.805, P3: 66.473, P50: 70.622, P97: 74.772, P999: 77.44 },
  { Month: 9, P01: 65.039, P3: 67.752, P50: 71.971, P97: 76.191, P999: 78.904 },
  { Month: 10, P01: 66.206, P3: 68.969, P50: 73.265, P97: 77.562, P999: 80.325 },
  { Month: 11, P01: 67.347, P3: 70.165, P50: 74.546, P97: 78.928, P999: 81.745 },
  { Month: 12, P01: 68.397, P3: 71.27, P50: 75.739, P97: 80.208, P999: 83.081 },
  { Month: 13, P01: 69.432, P3: 72.367, P50: 76.93, P97: 81.494, P999: 84.428 },
  { Month: 14, P01: 70.39, P3: 73.386, P50: 78.045, P97: 82.704, P999: 85.7 },
  { Month: 15, P01: 71.341, P3: 74.401, P50: 79.161, P97: 83.921, P999: 86.982 },
  { Month: 16, P01: 72.225, P3: 75.351, P50: 80.211, P97: 85.072, P999: 88.198 },
  { Month: 17, P01: 73.078, P3: 76.27, P50: 81.234, P97: 86.198, P999: 89.39 },
  { Month: 18, P01: 73.927, P3: 77.19, P50: 82.263, P97: 87.336, P999: 90.598 },
  { Month: 19, P01: 74.718, P3: 78.05, P50: 83.232, P97: 88.413, P999: 91.745 },
  { Month: 20, P01: 75.511, P3: 78.914, P50: 84.207, P97: 89.5, P999: 92.904 },
  { Month: 21, P01: 76.251, P3: 79.725, P50: 85.129, P97: 90.533, P999: 94.008 },
  { Month: 22, P01: 76.99, P3: 80.54, P50: 86.059, P97: 91.578, P999: 95.128 },
  { Month: 23, P01: 77.684, P3: 81.306, P50: 86.939, P97: 92.572, P999: 96.195 },
  { Month: 24, P01: 78.362, P3: 82.057, P50: 87.802, P97: 93.547, P999: 97.241 },
  { Month: 25, P01: 78.344, P3: 82.113, P50: 87.974, P97: 93.834, P999: 97.603 },
  { Month: 26, P01: 78.984, P3: 82.824, P50: 88.796, P97: 94.769, P999: 98.609 },
  { Month: 27, P01: 79.626, P3: 83.539, P50: 89.625, P97: 95.71, P999: 99.623 },
  { Month: 28, P01: 80.231, P3: 84.213, P50: 90.406, P97: 96.598, P999: 100.58 },
  { Month: 29, P01: 80.837, P3: 84.889, P50: 91.191, P97: 97.492, P999: 101.544 },
  { Month: 30, P01: 81.407, P3: 85.525, P50: 91.93, P97: 98.334, P999: 102.452 },
  { Month: 31, P01: 81.983, P3: 86.167, P50: 92.674, P97: 99.18, P999: 103.364 },
  { Month: 32, P01: 82.523, P3: 86.77, P50: 93.375, P97: 99.98, P999: 104.228 },
  { Month: 33, P01: 83.053, P3: 87.362, P50: 94.061, P97: 100.761, P999: 105.069 },
  { Month: 34, P01: 83.594, P3: 87.962, P50: 94.756, P97: 101.55, P999: 105.918 },
  { Month: 35, P01: 84.106, P3: 88.533, P50: 95.417, P97: 102.301, P999: 106.728 },
  { Month: 36, P01: 84.633, P3: 89.117, P50: 96.089, P97: 103.061, P999: 107.545 },
  { Month: 37, P01: 85.135, P3: 89.673, P50: 96.73, P97: 103.787, P999: 108.325 },
  { Month: 38, P01: 85.646, P3: 90.24, P50: 97.383, P97: 104.526, P999: 109.119 },
  { Month: 39, P01: 86.137, P3: 90.782, P50: 98.006, P97: 105.23, P999: 109.875 },
  { Month: 40, P01: 86.64, P3: 91.337, P50: 98.641, P97: 105.945, P999: 110.642 },
  { Month: 41, P01: 87.12, P3: 91.866, P50: 99.247, P97: 106.628, P999: 111.374 },
  { Month: 42, P01: 87.595, P3: 92.389, P50: 99.844, P97: 107.299, P999: 112.093 },
  { Month: 43, P01: 88.079, P3: 92.921, P50: 100.452, P97: 107.983, P999: 112.826 },
  { Month: 44, P01: 88.538, P3: 93.428, P50: 101.033, P97: 108.637, P999: 113.527 },
  { Month: 45, P01: 89.009, P3: 93.947, P50: 101.625, P97: 109.302, P999: 114.24 },
  { Month: 46, P01: 89.461, P3: 94.443, P50: 102.191, P97: 109.939, P999: 114.921 },
  { Month: 47, P01: 89.924, P3: 94.952, P50: 102.771, P97: 110.589, P999: 115.617 },
  { Month: 48, P01: 90.367, P3: 95.439, P50: 103.327, P97: 111.215, P999: 116.288 },
  { Month: 49, P01: 90.806, P3: 95.923, P50: 103.881, P97: 111.838, P999: 116.956 },
  { Month: 50, P01: 91.261, P3: 96.423, P50: 104.45, P97: 112.476, P999: 117.638 },
  { Month: 51, P01: 91.695, P3: 96.902, P50: 104.998, P97: 113.095, P999: 118.302 },
  { Month: 52, P01: 92.147, P3: 97.398, P50: 105.564, P97: 113.73, P999: 118.981 },
  { Month: 53, P01: 92.581, P3: 97.876, P50: 106.11, P97: 114.345, P999: 119.64 },
  { Month: 54, P01: 93.03, P3: 98.369, P50: 106.674, P97: 114.978, P999: 120.318 },
  { Month: 55, P01: 93.461, P3: 98.845, P50: 107.218, P97: 115.59, P999: 120.974 },
  { Month: 56, P01: 93.891, P3: 99.319, P50: 107.761, P97: 116.202, P999: 121.63 },
  { Month: 57, P01: 94.339, P3: 99.811, P50: 108.321, P97: 116.831, P999: 122.303 },
  { Month: 58, P01: 94.767, P3: 100.283, P50: 108.862, P97: 117.441, P999: 122.958 },
  { Month: 59, P01: 95.212, P3: 100.773, P50: 109.42, P97: 118.068, P999: 123.629 },
  { Month: 60, P01: 95.64, P3: 101.244, P50: 109.959, P97: 118.674, P999: 124.278 }
];

// ========== Girls Height 0-5 years (WHO Length/Height-for-age, 5 percentile lines, sampled monthly) ==========
const GIRLS_HEIGHT_0_5_RAW = [
  { Month: 0, P01: 43.392, P3: 45.644, P50: 49.148, P97: 52.651, P999: 54.904 },
  { Month: 1, P01: 47.598, P3: 49.96, P50: 53.633, P97: 57.305, P999: 59.667 },
  { Month: 2, P01: 50.786, P3: 53.249, P50: 57.08, P97: 60.91, P999: 63.373 },
  { Month: 3, P01: 53.275, P3: 55.82, P50: 59.777, P97: 63.735, P999: 66.28 },
  { Month: 4, P01: 55.417, P3: 58.035, P50: 62.107, P97: 66.179, P999: 68.798 },
  { Month: 5, P01: 57.168, P3: 59.849, P50: 64.019, P97: 68.189, P999: 70.87 },
  { Month: 6, P01: 58.745, P3: 61.487, P50: 65.751, P97: 70.015, P999: 72.757 },
  { Month: 7, P01: 60.13, P3: 62.93, P50: 67.284, P97: 71.639, P999: 74.439 },
  { Month: 8, P01: 61.462, P3: 64.324, P50: 68.773, P97: 73.223, P999: 76.084 },
  { Month: 9, P01: 62.681, P3: 65.603, P50: 70.146, P97: 74.69, P999: 77.612 },
  { Month: 10, P01: 63.842, P3: 66.826, P50: 71.466, P97: 76.106, P999: 79.089 },
  { Month: 11, P01: 64.988, P3: 68.037, P50: 72.779, P97: 77.52, P999: 80.569 },
  { Month: 12, P01: 66.049, P3: 69.163, P50: 74.005, P97: 78.847, P999: 81.961 },
  { Month: 13, P01: 67.102, P3: 70.283, P50: 75.23, P97: 80.176, P999: 83.357 },
  { Month: 14, P01: 68.083, P3: 71.329, P50: 76.377, P97: 81.425, P999: 84.671 },
  { Month: 15, P01: 69.059, P3: 72.373, P50: 77.526, P97: 82.679, P999: 85.992 },
  { Month: 16, P01: 69.97, P3: 73.35, P50: 78.606, P97: 83.861, P999: 87.241 },
  { Month: 17, P01: 70.853, P3: 74.298, P50: 79.656, P97: 85.013, P999: 88.458 },
  { Month: 18, P01: 71.738, P3: 75.25, P50: 80.712, P97: 86.174, P999: 89.686 },
  { Month: 19, P01: 72.568, P3: 76.145, P50: 81.708, P97: 87.271, P999: 90.848 },
  { Month: 20, P01: 73.4, P3: 77.044, P50: 82.712, P97: 88.379, P999: 92.023 },
  { Month: 21, P01: 74.184, P3: 77.893, P50: 83.66, P97: 89.426, P999: 93.135 },
  { Month: 22, P01: 74.969, P3: 78.745, P50: 84.615, P97: 90.486, P999: 94.261 },
  { Month: 23, P01: 75.711, P3: 79.55, P50: 85.518, P97: 91.487, P999: 95.326 },
  { Month: 24, P01: 76.434, P3: 80.335, P50: 86.401, P97: 92.467, P999: 96.368 },
  { Month: 25, P01: 76.461, P3: 80.426, P50: 86.592, P97: 92.758, P999: 96.723 },
  { Month: 26, P01: 77.147, P3: 81.174, P50: 87.436, P97: 93.698, P999: 97.725 },
  { Month: 27, P01: 77.839, P3: 81.928, P50: 88.288, P97: 94.648, P999: 98.738 },
  { Month: 28, P01: 78.491, P3: 82.641, P50: 89.094, P97: 95.547, P999: 99.696 },
  { Month: 29, P01: 79.149, P3: 83.36, P50: 89.907, P97: 96.455, P999: 100.665 },
  { Month: 30, P01: 79.768, P3: 84.037, P50: 90.677, P97: 97.316, P999: 101.585 },
  { Month: 31, P01: 80.395, P3: 84.723, P50: 91.454, P97: 98.184, P999: 102.513 },
  { Month: 32, P01: 80.986, P3: 85.371, P50: 92.191, P97: 99.01, P999: 103.395 },
  { Month: 33, P01: 81.566, P3: 86.007, P50: 92.914, P97: 99.82, P999: 104.261 },
  { Month: 34, P01: 82.156, P3: 86.653, P50: 93.647, P97: 100.641, P999: 105.139 },
  { Month: 35, P01: 82.716, P3: 87.268, P50: 94.346, P97: 101.424, P999: 105.976 },
  { Month: 36, P01: 83.287, P3: 87.893, P50: 95.057, P97: 102.221, P999: 106.828 },
  { Month: 37, P01: 83.831, P3: 88.49, P50: 95.736, P97: 102.981, P999: 107.64 },
  { Month: 38, P01: 84.386, P3: 89.098, P50: 96.427, P97: 103.756, P999: 108.468 },
  { Month: 39, P01: 84.915, P3: 89.679, P50: 97.087, P97: 104.495, P999: 109.259 },
  { Month: 40, P01: 85.452, P3: 90.269, P50: 97.76, P97: 105.251, P999: 110.068 },
  { Month: 41, P01: 85.969, P3: 90.835, P50: 98.403, P97: 105.971, P999: 110.837 },
  { Month: 42, P01: 86.474, P3: 91.391, P50: 99.037, P97: 106.683, P999: 111.6 },
  { Month: 43, P01: 86.992, P3: 91.959, P50: 99.683, P97: 107.408, P999: 112.375 },
  { Month: 44, P01: 87.484, P3: 92.5, P50: 100.301, P97: 108.101, P999: 113.117 },
  { Month: 45, P01: 87.986, P3: 93.052, P50: 100.93, P97: 108.808, P999: 113.874 },
  { Month: 46, P01: 88.466, P3: 93.58, P50: 101.531, P97: 109.483, P999: 114.596 },
  { Month: 47, P01: 88.954, P3: 94.116, P50: 102.145, P97: 110.173, P999: 115.336 },
  { Month: 48, P01: 89.42, P3: 94.63, P50: 102.731, P97: 110.833, P999: 116.042 },
  { Month: 49, P01: 89.883, P3: 95.139, P50: 103.311, P97: 111.484, P999: 116.739 },
  { Month: 50, P01: 90.355, P3: 95.658, P50: 103.905, P97: 112.151, P999: 117.454 },
  { Month: 51, P01: 90.807, P3: 96.155, P50: 104.473, P97: 112.79, P999: 118.139 },
  { Month: 52, P01: 91.267, P3: 96.663, P50: 105.054, P97: 113.446, P999: 118.842 },
  { Month: 53, P01: 91.712, P3: 97.152, P50: 105.611, P97: 114.071, P999: 119.511 },
  { Month: 54, P01: 92.164, P3: 97.65, P50: 106.182, P97: 114.713, P999: 120.199 },
  { Month: 55, P01: 92.596, P3: 98.127, P50: 106.728, P97: 115.33, P999: 120.861 },
  { Month: 56, P01: 93.026, P3: 98.601, P50: 107.27, P97: 115.939, P999: 121.514 },
  { Month: 57, P01: 93.463, P3: 99.083, P50: 107.824, P97: 116.564, P999: 122.185 },
  { Month: 58, P01: 93.883, P3: 99.547, P50: 108.355, P97: 117.163, P999: 122.827 },
  { Month: 59, P01: 94.31, P3: 100.019, P50: 108.898, P97: 117.777, P999: 123.486 },
  { Month: 60, P01: 94.724, P3: 100.475, P50: 109.419, P97: 118.363, P999: 124.114 }
];

// ========== Boys Weight 0-5 years (WHO Weight-for-age, 5 percentile lines) ==========
const BOYS_WEIGHT_0_5_RAW = [
  { Month: 0, P01: 2, P3: 2.5, P50: 3.3, P97: 4.3, P999: 5.1 },
  { Month: 1, P01: 2.9, P3: 3.4, P50: 4.5, P97: 5.7, P999: 6.6 },
  { Month: 2, P01: 3.7, P3: 4.4, P50: 5.6, P97: 7, P999: 8.1 },
  { Month: 3, P01: 4.4, P3: 5.1, P50: 6.4, P97: 7.9, P999: 9.1 },
  { Month: 4, P01: 4.9, P3: 5.6, P50: 7, P97: 8.6, P999: 9.8 },
  { Month: 5, P01: 5.3, P3: 6.1, P50: 7.5, P97: 9.2, P999: 10.5 },
  { Month: 6, P01: 5.6, P3: 6.4, P50: 7.9, P97: 9.7, P999: 11.1 },
  { Month: 7, P01: 5.9, P3: 6.7, P50: 8.3, P97: 10.2, P999: 11.5 },
  { Month: 8, P01: 6.1, P3: 7, P50: 8.6, P97: 10.5, P999: 12 },
  { Month: 9, P01: 6.3, P3: 7.2, P50: 8.9, P97: 10.9, P999: 12.4 },
  { Month: 10, P01: 6.5, P3: 7.5, P50: 9.2, P97: 11.2, P999: 12.8 },
  { Month: 11, P01: 6.7, P3: 7.7, P50: 9.4, P97: 11.5, P999: 13.1 },
  { Month: 12, P01: 6.9, P3: 7.8, P50: 9.6, P97: 11.8, P999: 13.5 },
  { Month: 13, P01: 7, P3: 8, P50: 9.9, P97: 12.1, P999: 13.8 },
  { Month: 14, P01: 7.2, P3: 8.2, P50: 10.1, P97: 12.4, P999: 14.1 },
  { Month: 15, P01: 7.3, P3: 8.4, P50: 10.3, P97: 12.7, P999: 14.5 },
  { Month: 16, P01: 7.5, P3: 8.5, P50: 10.5, P97: 12.9, P999: 14.8 },
  { Month: 17, P01: 7.6, P3: 8.7, P50: 10.7, P97: 13.2, P999: 15.1 },
  { Month: 18, P01: 7.7, P3: 8.9, P50: 10.9, P97: 13.5, P999: 15.4 },
  { Month: 19, P01: 7.9, P3: 9, P50: 11.1, P97: 13.7, P999: 15.7 },
  { Month: 20, P01: 8, P3: 9.2, P50: 11.3, P97: 14, P999: 16 },
  { Month: 21, P01: 8.2, P3: 9.3, P50: 11.5, P97: 14.3, P999: 16.4 },
  { Month: 22, P01: 8.3, P3: 9.5, P50: 11.8, P97: 14.5, P999: 16.7 },
  { Month: 23, P01: 8.4, P3: 9.7, P50: 12, P97: 14.8, P999: 17 },
  { Month: 24, P01: 8.5, P3: 9.8, P50: 12.2, P97: 15.1, P999: 17.3 },
  { Month: 25, P01: 8.7, P3: 10, P50: 12.4, P97: 15.3, P999: 17.6 },
  { Month: 26, P01: 8.8, P3: 10.1, P50: 12.5, P97: 15.6, P999: 18 },
  { Month: 27, P01: 8.9, P3: 10.2, P50: 12.7, P97: 15.9, P999: 18.3 },
  { Month: 28, P01: 9, P3: 10.4, P50: 12.9, P97: 16.1, P999: 18.6 },
  { Month: 29, P01: 9.2, P3: 10.5, P50: 13.1, P97: 16.4, P999: 18.9 },
  { Month: 30, P01: 9.3, P3: 10.7, P50: 13.3, P97: 16.6, P999: 19.2 },
  { Month: 31, P01: 9.4, P3: 10.8, P50: 13.5, P97: 16.9, P999: 19.5 },
  { Month: 32, P01: 9.5, P3: 10.9, P50: 13.7, P97: 17.1, P999: 19.8 },
  { Month: 33, P01: 9.6, P3: 11.1, P50: 13.8, P97: 17.3, P999: 20.1 },
  { Month: 34, P01: 9.7, P3: 11.2, P50: 14, P97: 17.6, P999: 20.4 },
  { Month: 35, P01: 9.8, P3: 11.3, P50: 14.2, P97: 17.8, P999: 20.7 },
  { Month: 36, P01: 9.9, P3: 11.4, P50: 14.3, P97: 18, P999: 21 },
  { Month: 37, P01: 10, P3: 11.6, P50: 14.5, P97: 18.3, P999: 21.2 },
  { Month: 38, P01: 10.1, P3: 11.7, P50: 14.7, P97: 18.5, P999: 21.5 },
  { Month: 39, P01: 10.2, P3: 11.8, P50: 14.8, P97: 18.7, P999: 21.8 },
  { Month: 40, P01: 10.3, P3: 11.9, P50: 15, P97: 19, P999: 22.1 },
  { Month: 41, P01: 10.4, P3: 12.1, P50: 15.2, P97: 19.2, P999: 22.4 },
  { Month: 42, P01: 10.5, P3: 12.2, P50: 15.3, P97: 19.4, P999: 22.7 },
  { Month: 43, P01: 10.6, P3: 12.3, P50: 15.5, P97: 19.7, P999: 23 },
  { Month: 44, P01: 10.7, P3: 12.4, P50: 15.7, P97: 19.9, P999: 23.3 },
  { Month: 45, P01: 10.8, P3: 12.5, P50: 15.8, P97: 20.1, P999: 23.6 },
  { Month: 46, P01: 10.9, P3: 12.7, P50: 16, P97: 20.4, P999: 23.9 },
  { Month: 47, P01: 11, P3: 12.8, P50: 16.2, P97: 20.6, P999: 24.2 },
  { Month: 48, P01: 11.1, P3: 12.9, P50: 16.3, P97: 20.9, P999: 24.5 },
  { Month: 49, P01: 11.2, P3: 13, P50: 16.5, P97: 21.1, P999: 24.8 },
  { Month: 50, P01: 11.3, P3: 13.1, P50: 16.7, P97: 21.3, P999: 25.1 },
  { Month: 51, P01: 11.4, P3: 13.3, P50: 16.8, P97: 21.6, P999: 25.4 },
  { Month: 52, P01: 11.5, P3: 13.4, P50: 17, P97: 21.8, P999: 25.7 },
  { Month: 53, P01: 11.6, P3: 13.5, P50: 17.2, P97: 22.1, P999: 26 },
  { Month: 54, P01: 11.7, P3: 13.6, P50: 17.3, P97: 22.3, P999: 26.3 },
  { Month: 55, P01: 11.8, P3: 13.7, P50: 17.5, P97: 22.5, P999: 26.6 },
  { Month: 56, P01: 11.9, P3: 13.8, P50: 17.7, P97: 22.8, P999: 27 },
  { Month: 57, P01: 12, P3: 13.9, P50: 17.8, P97: 23, P999: 27.3 },
  { Month: 58, P01: 12, P3: 14.1, P50: 18, P97: 23.3, P999: 27.6 },
  { Month: 59, P01: 12.1, P3: 14.2, P50: 18.2, P97: 23.5, P999: 27.9 },
  { Month: 60, P01: 12.2, P3: 14.3, P50: 18.3, P97: 23.8, P999: 28.2 }
];

// ========== Girls Weight 0-5 years (WHO Weight-for-age, 5 percentile lines) ==========
const GIRLS_WEIGHT_0_5_RAW = [
  { Month: 0, P01: 2, P3: 2.4, P50: 3.2, P97: 4.2, P999: 4.8 },
  { Month: 1, P01: 2.7, P3: 3.2, P50: 4.2, P97: 5.4, P999: 6.3 },
  { Month: 2, P01: 3.4, P3: 4, P50: 5.1, P97: 6.5, P999: 7.6 },
  { Month: 3, P01: 3.9, P3: 4.6, P50: 5.8, P97: 7.4, P999: 8.6 },
  { Month: 4, P01: 4.4, P3: 5.1, P50: 6.4, P97: 8.1, P999: 9.4 },
  { Month: 5, P01: 4.7, P3: 5.5, P50: 6.9, P97: 8.7, P999: 10.1 },
  { Month: 6, P01: 5, P3: 5.8, P50: 7.3, P97: 9.2, P999: 10.7 },
  { Month: 7, P01: 5.3, P3: 6.1, P50: 7.6, P97: 9.6, P999: 11.2 },
  { Month: 8, P01: 5.5, P3: 6.3, P50: 7.9, P97: 10, P999: 11.7 },
  { Month: 9, P01: 5.7, P3: 6.6, P50: 8.2, P97: 10.4, P999: 12.1 },
  { Month: 10, P01: 5.9, P3: 6.8, P50: 8.5, P97: 10.7, P999: 12.5 },
  { Month: 11, P01: 6, P3: 7, P50: 8.7, P97: 11, P999: 12.9 },
  { Month: 12, P01: 6.2, P3: 7.1, P50: 8.9, P97: 11.3, P999: 13.3 },
  { Month: 13, P01: 6.4, P3: 7.3, P50: 9.2, P97: 11.6, P999: 13.6 },
  { Month: 14, P01: 6.5, P3: 7.5, P50: 9.4, P97: 11.9, P999: 14 },
  { Month: 15, P01: 6.7, P3: 7.7, P50: 9.6, P97: 12.2, P999: 14.3 },
  { Month: 16, P01: 6.8, P3: 7.8, P50: 9.8, P97: 12.5, P999: 14.6 },
  { Month: 17, P01: 7, P3: 8, P50: 10, P97: 12.7, P999: 15 },
  { Month: 18, P01: 7.1, P3: 8.2, P50: 10.2, P97: 13, P999: 15.3 },
  { Month: 19, P01: 7.3, P3: 8.3, P50: 10.4, P97: 13.3, P999: 15.6 },
  { Month: 20, P01: 7.4, P3: 8.5, P50: 10.6, P97: 13.5, P999: 15.9 },
  { Month: 21, P01: 7.6, P3: 8.7, P50: 10.9, P97: 13.8, P999: 16.2 },
  { Month: 22, P01: 7.7, P3: 8.8, P50: 11.1, P97: 14.1, P999: 16.6 },
  { Month: 23, P01: 7.8, P3: 9, P50: 11.3, P97: 14.3, P999: 16.9 },
  { Month: 24, P01: 8, P3: 9.2, P50: 11.5, P97: 14.6, P999: 17.2 },
  { Month: 25, P01: 8.1, P3: 9.3, P50: 11.7, P97: 14.9, P999: 17.6 },
  { Month: 26, P01: 8.3, P3: 9.5, P50: 11.9, P97: 15.2, P999: 17.9 },
  { Month: 27, P01: 8.4, P3: 9.6, P50: 12.1, P97: 15.4, P999: 18.2 },
  { Month: 28, P01: 8.5, P3: 9.8, P50: 12.3, P97: 15.7, P999: 18.6 },
  { Month: 29, P01: 8.7, P3: 10, P50: 12.5, P97: 16, P999: 18.9 },
  { Month: 30, P01: 8.8, P3: 10.1, P50: 12.7, P97: 16.2, P999: 19.2 },
  { Month: 31, P01: 8.9, P3: 10.3, P50: 12.9, P97: 16.5, P999: 19.6 },
  { Month: 32, P01: 9, P3: 10.4, P50: 13.1, P97: 16.8, P999: 19.9 },
  { Month: 33, P01: 9.2, P3: 10.5, P50: 13.3, P97: 17, P999: 20.2 },
  { Month: 34, P01: 9.3, P3: 10.7, P50: 13.5, P97: 17.3, P999: 20.6 },
  { Month: 35, P01: 9.4, P3: 10.8, P50: 13.7, P97: 17.6, P999: 20.9 },
  { Month: 36, P01: 9.5, P3: 11, P50: 13.9, P97: 17.8, P999: 21.2 },
  { Month: 37, P01: 9.6, P3: 11.1, P50: 14, P97: 18.1, P999: 21.6 },
  { Month: 38, P01: 9.7, P3: 11.2, P50: 14.2, P97: 18.4, P999: 21.9 },
  { Month: 39, P01: 9.8, P3: 11.4, P50: 14.4, P97: 18.6, P999: 22.3 },
  { Month: 40, P01: 10, P3: 11.5, P50: 14.6, P97: 18.9, P999: 22.6 },
  { Month: 41, P01: 10.1, P3: 11.6, P50: 14.8, P97: 19.2, P999: 23 },
  { Month: 42, P01: 10.2, P3: 11.8, P50: 15, P97: 19.5, P999: 23.3 },
  { Month: 43, P01: 10.3, P3: 11.9, P50: 15.2, P97: 19.7, P999: 23.7 },
  { Month: 44, P01: 10.4, P3: 12, P50: 15.3, P97: 20, P999: 24.1 },
  { Month: 45, P01: 10.5, P3: 12.1, P50: 15.5, P97: 20.3, P999: 24.4 },
  { Month: 46, P01: 10.6, P3: 12.3, P50: 15.7, P97: 20.6, P999: 24.8 },
  { Month: 47, P01: 10.7, P3: 12.4, P50: 15.9, P97: 20.8, P999: 25.2 },
  { Month: 48, P01: 10.8, P3: 12.5, P50: 16.1, P97: 21.1, P999: 25.5 },
  { Month: 49, P01: 10.9, P3: 12.6, P50: 16.3, P97: 21.4, P999: 25.9 },
  { Month: 50, P01: 11, P3: 12.8, P50: 16.4, P97: 21.7, P999: 26.3 },
  { Month: 51, P01: 11.1, P3: 12.9, P50: 16.6, P97: 22, P999: 26.7 },
  { Month: 52, P01: 11.2, P3: 13, P50: 16.8, P97: 22.2, P999: 27 },
  { Month: 53, P01: 11.3, P3: 13.1, P50: 17, P97: 22.5, P999: 27.4 },
  { Month: 54, P01: 11.3, P3: 13.2, P50: 17.2, P97: 22.8, P999: 27.8 },
  { Month: 55, P01: 11.4, P3: 13.4, P50: 17.3, P97: 23.1, P999: 28.2 },
  { Month: 56, P01: 11.5, P3: 13.5, P50: 17.5, P97: 23.3, P999: 28.5 },
  { Month: 57, P01: 11.6, P3: 13.6, P50: 17.7, P97: 23.6, P999: 28.9 },
  { Month: 58, P01: 11.7, P3: 13.7, P50: 17.9, P97: 23.9, P999: 29.3 },
  { Month: 59, P01: 11.8, P3: 13.8, P50: 18, P97: 24.2, P999: 29.6 },
  { Month: 60, P01: 11.9, P3: 14, P50: 18.2, P97: 24.4, P999: 30 }
];
// ========== Girls Weight 5-18 years (IAP 2015 Indian Pediatrics, 7 percentile lines, every 6 months) ==========
const GIRLS_WEIGHT_5_18_RAW = [
  { Month: 60, p3: 12.3, p10: 13.4, p25: 14.8, p50: 16.4, p75: 18.5, p90: 21.3, p97: 25.0 },
  { Month: 66, p3: 13.0, p10: 14.3, p25: 15.7, p50: 17.6, p75: 19.9, p90: 22.9, p97: 27.0 },
  { Month: 72, p3: 13.7, p10: 15.1, p25: 16.7, p50: 18.7, p75: 21.3, p90: 24.6, p97: 29.1 },
  { Month: 78, p3: 14.4, p10: 15.9, p25: 17.7, p50: 19.9, p75: 22.7, p90: 26.3, p97: 31.2 },
  { Month: 84, p3: 15.1, p10: 16.8, p25: 18.7, p50: 21.2, p75: 24.2, p90: 28.2, p97: 33.4 },
  { Month: 90, p3: 15.9, p10: 17.7, p25: 19.9, p50: 22.5, p75: 25.9, p90: 30.1, p97: 35.7 },
  { Month: 96, p3: 16.7, p10: 18.7, p25: 21.1, p50: 24.0, p75: 27.6, p90: 32.2, p97: 38.1 },
  { Month: 102, p3: 17.5, p10: 19.7, p25: 22.3, p50: 25.5, p75: 29.5, p90: 34.4, p97: 40.7 },
  { Month: 108, p3: 18.5, p10: 20.9, p25: 23.7, p50: 27.2, p75: 31.5, p90: 36.7, p97: 43.4 },
  { Month: 114, p3: 19.5, p10: 22.1, p25: 25.3, p50: 29.0, p75: 33.6, p90: 39.3, p97: 46.3 },
  { Month: 120, p3: 20.7, p10: 23.5, p25: 26.9, p50: 31.0, p75: 36.0, p90: 42.0, p97: 49.4 },
  { Month: 126, p3: 22.0, p10: 25.1, p25: 28.8, p50: 33.2, p75: 38.4, p90: 44.8, p97: 52.6 },
  { Month: 132, p3: 23.3, p10: 26.7, p25: 30.7, p50: 35.4, p75: 41.0, p90: 47.7, p97: 55.9 },
  { Month: 138, p3: 24.8, p10: 28.4, p25: 32.6, p50: 37.6, p75: 43.6, p90: 50.6, p97: 59.1 },
  { Month: 144, p3: 26.2, p10: 30.0, p25: 34.5, p50: 39.8, p75: 46.0, p90: 53.4, p97: 62.1 },
  { Month: 150, p3: 27.6, p10: 31.6, p25: 36.3, p50: 41.8, p75: 48.2, p90: 55.8, p97: 64.8 },
  { Month: 156, p3: 28.9, p10: 33.1, p25: 37.9, p50: 43.6, p75: 50.2, p90: 57.9, p97: 67.1 },
  { Month: 162, p3: 30.2, p10: 34.4, p25: 39.4, p50: 45.1, p75: 51.8, p90: 59.7, p97: 69.0 },
  { Month: 168, p3: 31.3, p10: 35.6, p25: 40.6, p50: 46.4, p75: 53.2, p90: 61.1, p97: 70.4 },
  { Month: 174, p3: 32.3, p10: 36.6, p25: 41.7, p50: 47.5, p75: 54.3, p90: 62.2, p97: 71.4 },
  { Month: 180, p3: 33.1, p10: 37.5, p25: 42.5, p50: 48.4, p75: 55.1, p90: 62.9, p97: 72.1 },
  { Month: 186, p3: 34.0, p10: 38.3, p25: 43.3, p50: 49.1, p75: 55.8, p90: 63.5, p97: 72.5 },
  { Month: 192, p3: 34.7, p10: 39.1, p25: 44.0, p50: 49.7, p75: 56.3, p90: 64.0, p97: 72.8 },
  { Month: 198, p3: 35.5, p10: 39.8, p25: 44.7, p50: 50.3, p75: 56.9, p90: 64.4, p97: 73.1 },
  { Month: 204, p3: 36.2, p10: 40.5, p25: 45.3, p50: 50.9, p75: 57.3, p90: 64.7, p97: 73.3 },
  { Month: 210, p3: 36.9, p10: 41.1, p25: 46.0, p50: 51.5, p75: 57.8, p90: 65.0, p97: 73.4 },
  { Month: 216, p3: 37.6, p10: 41.8, p25: 46.6, p50: 52.0, p75: 58.2, p90: 65.3, p97: 73.5 }
];

// ========== Boys Weight 5-18 years (IAP 2015 Indian Pediatrics, 7 percentile lines, every 6 months) ==========
const BOYS_WEIGHT_5_18_RAW = [
  { Month: 60, p3: 13.2, p10: 14.3, p25: 15.6, p50: 17.1, p75: 19.0, p90: 21.3, p97: 24.2 },
  { Month: 66, p3: 13.8, p10: 15.0, p25: 16.5, p50: 18.2, p75: 20.3, p90: 22.9, p97: 26.1 },
  { Month: 72, p3: 14.5, p10: 15.8, p25: 17.4, p50: 19.3, p75: 21.7, p90: 24.6, p97: 28.3 },
  { Month: 78, p3: 15.3, p10: 16.8, p25: 18.6, p50: 20.7, p75: 23.3, p90: 26.6, p97: 30.8 },
  { Month: 84, p3: 16.0, p10: 17.6, p25: 19.6, p50: 21.9, p75: 24.9, p90: 28.6, p97: 33.4 },
  { Month: 90, p3: 16.7, p10: 18.5, p25: 20.7, p50: 23.3, p75: 26.6, p90: 30.8, p97: 36.2 },
  { Month: 96, p3: 17.5, p10: 19.5, p25: 21.9, p50: 24.8, p75: 28.5, p90: 33.2, p97: 39.4 },
  { Month: 102, p3: 18.3, p10: 20.5, p25: 23.2, p50: 26.4, p75: 30.5, p90: 35.7, p97: 42.6 },
  { Month: 108, p3: 19.1, p10: 21.5, p25: 24.3, p50: 27.9, p75: 32.3, p90: 38.0, p97: 45.5 },
  { Month: 114, p3: 19.9, p10: 22.4, p25: 25.6, p50: 29.4, p75: 34.3, p90: 40.5, p97: 48.6 },
  { Month: 120, p3: 20.7, p10: 23.5, p25: 26.9, p50: 31.1, p75: 36.3, p90: 43.0, p97: 51.8 },
  { Month: 126, p3: 21.6, p10: 24.6, p25: 28.3, p50: 32.8, p75: 38.5, p90: 45.8, p97: 55.2 },
  { Month: 132, p3: 22.6, p10: 25.9, p25: 29.8, p50: 34.7, p75: 40.9, p90: 48.7, p97: 58.7 },
  { Month: 138, p3: 23.8, p10: 27.3, p25: 31.6, p50: 36.9, p75: 43.5, p90: 51.8, p97: 62.5 },
  { Month: 144, p3: 24.9, p10: 28.7, p25: 33.3, p50: 39.0, p75: 46.0, p90: 54.8, p97: 66.1 },
  { Month: 150, p3: 26.1, p10: 30.2, p25: 35.1, p50: 41.2, p75: 48.6, p90: 57.8, p97: 69.5 },
  { Month: 156, p3: 27.5, p10: 31.8, p25: 37.0, p50: 43.3, p75: 51.1, p90: 60.7, p97: 72.6 },
  { Month: 162, p3: 29.0, p10: 33.6, p25: 39.1, p50: 45.7, p75: 53.8, p90: 63.6, p97: 75.6 },
  { Month: 168, p3: 30.7, p10: 35.5, p25: 41.3, p50: 48.2, p75: 56.4, p90: 66.3, p97: 78.3 },
  { Month: 174, p3: 32.6, p10: 37.7, p25: 43.7, p50: 50.8, p75: 59.1, p90: 69.1, p97: 80.9 },
  { Month: 180, p3: 34.5, p10: 39.8, p25: 45.9, p50: 53.1, p75: 61.6, p90: 71.5, p97: 83.1 },
  { Month: 186, p3: 36.1, p10: 41.6, p25: 47.9, p50: 55.2, p75: 63.6, p90: 73.4, p97: 84.7 },
  { Month: 192, p3: 37.5, p10: 43.1, p25: 49.5, p50: 56.8, p75: 65.2, p90: 74.8, p97: 85.8 },
  { Month: 198, p3: 38.7, p10: 44.4, p25: 50.9, p50: 58.2, p75: 66.6, p90: 76.1, p97: 86.8 },
  { Month: 204, p3: 39.8, p10: 45.6, p25: 52.1, p50: 59.5, p75: 67.8, p90: 77.1, p97: 87.5 },
  { Month: 210, p3: 40.8, p10: 46.7, p25: 53.2, p50: 60.6, p75: 68.7, p90: 77.8, p97: 88.0 },
  { Month: 216, p3: 41.8, p10: 47.7, p25: 54.3, p50: 61.6, p75: 69.7, p90: 78.6, p97: 88.4 }
];

// ========== Boys BMI 0-5 years (WHO BMI-for-age, 5 percentile lines, sampled monthly) ==========
const BOYS_BMI_0_5_RAW = [
  { Month: 0, P01: 10.104, P3: 11.254, P50: 13.407, P97: 16.13, P999: 18.272 },
  { Month: 1, P01: 11.155, P3: 12.532, P50: 14.914, P97: 17.609, P999: 19.518 },
  { Month: 2, P01: 12.433, P3: 13.845, P50: 16.323, P97: 19.188, P999: 21.259 },
  { Month: 3, P01: 12.99, P3: 14.399, P50: 16.895, P97: 19.82, P999: 21.962 },
  { Month: 4, P01: 13.277, P3: 14.671, P50: 17.159, P97: 20.106, P999: 22.285 },
  { Month: 5, P01: 13.44, P3: 14.817, P50: 17.291, P97: 20.246, P999: 22.448 },
  { Month: 6, P01: 13.528, P3: 14.888, P50: 17.342, P97: 20.294, P999: 22.511 },
  { Month: 7, P01: 13.556, P3: 14.898, P50: 17.329, P97: 20.271, P999: 22.493 },
  { Month: 8, P01: 13.539, P3: 14.86, P50: 17.263, P97: 20.187, P999: 22.408 },
  { Month: 9, P01: 13.491, P3: 14.792, P50: 17.166, P97: 20.068, P999: 22.283 },
  { Month: 10, P01: 13.426, P3: 14.707, P50: 17.05, P97: 19.928, P999: 22.133 },
  { Month: 11, P01: 13.349, P3: 14.61, P50: 16.923, P97: 19.774, P999: 21.97 },
  { Month: 12, P01: 13.272, P3: 14.515, P50: 16.799, P97: 19.626, P999: 21.81 },
  { Month: 13, P01: 13.192, P3: 14.417, P50: 16.673, P97: 19.474, P999: 21.646 },
  { Month: 14, P01: 13.116, P3: 14.325, P50: 16.555, P97: 19.333, P999: 21.494 },
  { Month: 15, P01: 13.04, P3: 14.234, P50: 16.439, P97: 19.194, P999: 21.344 },
  { Month: 16, P01: 12.971, P3: 14.151, P50: 16.334, P97: 19.067, P999: 21.207 },
  { Month: 17, P01: 12.906, P3: 14.072, P50: 16.234, P97: 18.949, P999: 21.079 },
  { Month: 18, P01: 12.844, P3: 13.997, P50: 16.139, P97: 18.834, P999: 20.955 },
  { Month: 19, P01: 12.788, P3: 13.93, P50: 16.054, P97: 18.731, P999: 20.843 },
  { Month: 20, P01: 12.736, P3: 13.868, P50: 15.974, P97: 18.635, P999: 20.74 },
  { Month: 21, P01: 12.692, P3: 13.814, P50: 15.904, P97: 18.551, P999: 20.648 },
  { Month: 22, P01: 12.652, P3: 13.765, P50: 15.841, P97: 18.474, P999: 20.566 },
  { Month: 23, P01: 12.618, P3: 13.722, P50: 15.785, P97: 18.407, P999: 20.493 },
  { Month: 24, P01: 12.588, P3: 13.685, P50: 15.736, P97: 18.347, P999: 20.428 },
  { Month: 25, P01: 12.756, P3: 13.884, P50: 15.98, P97: 18.626, P999: 20.714 },
  { Month: 26, P01: 12.713, P3: 13.844, P50: 15.942, P97: 18.576, P999: 20.645 },
  { Month: 27, P01: 12.668, P3: 13.804, P50: 15.903, P97: 18.528, P999: 20.579 },
  { Month: 28, P01: 12.626, P3: 13.766, P50: 15.867, P97: 18.482, P999: 20.516 },
  { Month: 29, P01: 12.584, P3: 13.727, P50: 15.83, P97: 18.437, P999: 20.455 },
  { Month: 30, P01: 12.543, P3: 13.691, P50: 15.795, P97: 18.394, P999: 20.4 },
  { Month: 31, P01: 12.502, P3: 13.653, P50: 15.76, P97: 18.352, P999: 20.345 },
  { Month: 32, P01: 12.463, P3: 13.618, P50: 15.727, P97: 18.313, P999: 20.295 },
  { Month: 33, P01: 12.425, P3: 13.583, P50: 15.694, P97: 18.276, P999: 20.249 },
  { Month: 34, P01: 12.388, P3: 13.548, P50: 15.661, P97: 18.239, P999: 20.204 },
  { Month: 35, P01: 12.352, P3: 13.515, P50: 15.63, P97: 18.205, P999: 20.164 },
  { Month: 36, P01: 12.317, P3: 13.482, P50: 15.599, P97: 18.172, P999: 20.127 },
  { Month: 37, P01: 12.284, P3: 13.451, P50: 15.57, P97: 18.143, P999: 20.095 },
  { Month: 38, P01: 12.252, P3: 13.42, P50: 15.541, P97: 18.115, P999: 20.066 },
  { Month: 39, P01: 12.222, P3: 13.392, P50: 15.514, P97: 18.09, P999: 20.043 },
  { Month: 40, P01: 12.193, P3: 13.364, P50: 15.488, P97: 18.068, P999: 20.024 },
  { Month: 41, P01: 12.167, P3: 13.338, P50: 15.465, P97: 18.049, P999: 20.01 },
  { Month: 42, P01: 12.142, P3: 13.313, P50: 15.442, P97: 18.033, P999: 20 },
  { Month: 43, P01: 12.118, P3: 13.289, P50: 15.421, P97: 18.018, P999: 19.994 },
  { Month: 44, P01: 12.096, P3: 13.268, P50: 15.402, P97: 18.007, P999: 19.993 },
  { Month: 45, P01: 12.075, P3: 13.246, P50: 15.383, P97: 17.998, P999: 19.996 },
  { Month: 46, P01: 12.055, P3: 13.225, P50: 15.365, P97: 17.991, P999: 20.003 },
  { Month: 47, P01: 12.036, P3: 13.206, P50: 15.348, P97: 17.986, P999: 20.013 },
  { Month: 48, P01: 12.019, P3: 13.187, P50: 15.333, P97: 17.983, P999: 20.027 },
  { Month: 49, P01: 12.002, P3: 13.169, P50: 15.318, P97: 17.982, P999: 20.044 },
  { Month: 50, P01: 11.986, P3: 13.151, P50: 15.303, P97: 17.983, P999: 20.065 },
  { Month: 51, P01: 11.971, P3: 13.134, P50: 15.289, P97: 17.985, P999: 20.089 },
  { Month: 52, P01: 11.956, P3: 13.118, P50: 15.276, P97: 17.989, P999: 20.118 },
  { Month: 53, P01: 11.943, P3: 13.102, P50: 15.263, P97: 17.994, P999: 20.148 },
  { Month: 54, P01: 11.931, P3: 13.087, P50: 15.251, P97: 18.001, P999: 20.183 },
  { Month: 55, P01: 11.919, P3: 13.073, P50: 15.24, P97: 18.009, P999: 20.219 },
  { Month: 56, P01: 11.908, P3: 13.059, P50: 15.229, P97: 18.019, P999: 20.259 },
  { Month: 57, P01: 11.897, P3: 13.046, P50: 15.219, P97: 18.03, P999: 20.303 },
  { Month: 58, P01: 11.888, P3: 13.033, P50: 15.209, P97: 18.042, P999: 20.349 },
  { Month: 59, P01: 11.879, P3: 13.021, P50: 15.2, P97: 18.057, P999: 20.399 },
  { Month: 60, P01: 11.871, P3: 13.01, P50: 15.192, P97: 18.072, P999: 20.451 }
];

// ========== Girls BMI 0-5 years (WHO BMI-for-age, 5 percentile lines, sampled monthly) ==========
const GIRLS_BMI_0_5_RAW = [
  { Month: 0, P01: 10.039, P3: 11.213, P50: 13.336, P97: 15.892, P999: 17.808 },
  { Month: 1, P01: 10.648, P3: 12.078, P50: 14.542, P97: 17.313, P999: 19.264 },
  { Month: 2, P01: 11.717, P3: 13.186, P50: 15.771, P97: 18.761, P999: 20.92 },
  { Month: 3, P01: 12.252, P3: 13.727, P50: 16.353, P97: 19.443, P999: 21.71 },
  { Month: 4, P01: 12.57, P3: 14.036, P50: 16.672, P97: 19.815, P999: 22.149 },
  { Month: 5, P01: 12.755, P3: 14.208, P50: 16.838, P97: 20.005, P999: 22.38 },
  { Month: 6, P01: 12.859, P3: 14.295, P50: 16.909, P97: 20.083, P999: 22.483 },
  { Month: 7, P01: 12.896, P3: 14.313, P50: 16.902, P97: 20.07, P999: 22.482 },
  { Month: 8, P01: 12.885, P3: 14.28, P50: 16.839, P97: 19.99, P999: 22.405 },
  { Month: 9, P01: 12.841, P3: 14.213, P50: 16.74, P97: 19.868, P999: 22.279 },
  { Month: 10, P01: 12.777, P3: 14.126, P50: 16.62, P97: 19.721, P999: 22.123 },
  { Month: 11, P01: 12.7, P3: 14.028, P50: 16.487, P97: 19.559, P999: 21.949 },
  { Month: 12, P01: 12.624, P3: 13.93, P50: 16.358, P97: 19.402, P999: 21.782 },
  { Month: 13, P01: 12.546, P3: 13.833, P50: 16.23, P97: 19.247, P999: 21.614 },
  { Month: 14, P01: 12.475, P3: 13.744, P50: 16.113, P97: 19.105, P999: 21.461 },
  { Month: 15, P01: 12.406, P3: 13.659, P50: 16.001, P97: 18.969, P999: 21.315 },
  { Month: 16, P01: 12.344, P3: 13.583, P50: 15.902, P97: 18.848, P999: 21.184 },
  { Month: 17, P01: 12.289, P3: 13.514, P50: 15.811, P97: 18.738, P999: 21.065 },
  { Month: 18, P01: 12.237, P3: 13.449, P50: 15.726, P97: 18.635, P999: 20.954 },
  { Month: 19, P01: 12.193, P3: 13.394, P50: 15.652, P97: 18.545, P999: 20.858 },
  { Month: 20, P01: 12.153, P3: 13.343, P50: 15.585, P97: 18.463, P999: 20.769 },
  { Month: 21, P01: 12.12, P3: 13.301, P50: 15.528, P97: 18.393, P999: 20.695 },
  { Month: 22, P01: 12.093, P3: 13.265, P50: 15.478, P97: 18.332, P999: 20.63 },
  { Month: 23, P01: 12.072, P3: 13.236, P50: 15.438, P97: 18.282, P999: 20.578 },
  { Month: 24, P01: 12.056, P3: 13.214, P50: 15.405, P97: 18.241, P999: 20.535 },
  { Month: 25, P01: 12.274, P3: 13.448, P50: 15.659, P97: 18.498, P999: 20.776 },
  { Month: 26, P01: 12.254, P3: 13.425, P50: 15.631, P97: 18.464, P999: 20.736 },
  { Month: 27, P01: 12.233, P3: 13.402, P50: 15.604, P97: 18.43, P999: 20.698 },
  { Month: 28, P01: 12.214, P3: 13.381, P50: 15.578, P97: 18.399, P999: 20.662 },
  { Month: 29, P01: 12.194, P3: 13.359, P50: 15.552, P97: 18.368, P999: 20.627 },
  { Month: 30, P01: 12.174, P3: 13.337, P50: 15.528, P97: 18.34, P999: 20.595 },
  { Month: 31, P01: 12.153, P3: 13.315, P50: 15.503, P97: 18.312, P999: 20.566 },
  { Month: 32, P01: 12.133, P3: 13.294, P50: 15.48, P97: 18.287, P999: 20.54 },
  { Month: 33, P01: 12.112, P3: 13.272, P50: 15.458, P97: 18.266, P999: 20.519 },
  { Month: 34, P01: 12.089, P3: 13.249, P50: 15.436, P97: 18.246, P999: 20.503 },
  { Month: 35, P01: 12.066, P3: 13.227, P50: 15.416, P97: 18.231, P999: 20.493 },
  { Month: 36, P01: 12.042, P3: 13.204, P50: 15.397, P97: 18.219, P999: 20.489 },
  { Month: 37, P01: 12.018, P3: 13.182, P50: 15.38, P97: 18.212, P999: 20.492 },
  { Month: 38, P01: 11.992, P3: 13.159, P50: 15.364, P97: 18.208, P999: 20.5 },
  { Month: 39, P01: 11.967, P3: 13.137, P50: 15.349, P97: 18.208, P999: 20.515 },
  { Month: 40, P01: 11.94, P3: 13.114, P50: 15.336, P97: 18.211, P999: 20.534 },
  { Month: 41, P01: 11.913, P3: 13.091, P50: 15.323, P97: 18.216, P999: 20.557 },
  { Month: 42, P01: 11.887, P3: 13.069, P50: 15.312, P97: 18.223, P999: 20.584 },
  { Month: 43, P01: 11.859, P3: 13.046, P50: 15.301, P97: 18.233, P999: 20.613 },
  { Month: 44, P01: 11.833, P3: 13.024, P50: 15.291, P97: 18.243, P999: 20.644 },
  { Month: 45, P01: 11.806, P3: 13.003, P50: 15.281, P97: 18.255, P999: 20.678 },
  { Month: 46, P01: 11.782, P3: 12.983, P50: 15.273, P97: 18.267, P999: 20.711 },
  { Month: 47, P01: 11.757, P3: 12.963, P50: 15.266, P97: 18.282, P999: 20.747 },
  { Month: 48, P01: 11.735, P3: 12.946, P50: 15.26, P97: 18.297, P999: 20.784 },
  { Month: 49, P01: 11.713, P3: 12.929, P50: 15.256, P97: 18.314, P999: 20.823 },
  { Month: 50, P01: 11.692, P3: 12.913, P50: 15.252, P97: 18.333, P999: 20.864 },
  { Month: 51, P01: 11.672, P3: 12.898, P50: 15.25, P97: 18.353, P999: 20.906 },
  { Month: 52, P01: 11.653, P3: 12.884, P50: 15.25, P97: 18.374, P999: 20.951 },
  { Month: 53, P01: 11.637, P3: 12.873, P50: 15.25, P97: 18.397, P999: 20.995 },
  { Month: 54, P01: 11.621, P3: 12.862, P50: 15.252, P97: 18.42, P999: 21.041 },
  { Month: 55, P01: 11.607, P3: 12.853, P50: 15.254, P97: 18.443, P999: 21.084 },
  { Month: 56, P01: 11.594, P3: 12.844, P50: 15.258, P97: 18.466, P999: 21.128 },
  { Month: 57, P01: 11.582, P3: 12.837, P50: 15.261, P97: 18.489, P999: 21.171 },
  { Month: 58, P01: 11.572, P3: 12.831, P50: 15.265, P97: 18.511, P999: 21.211 },
  { Month: 59, P01: 11.562, P3: 12.826, P50: 15.27, P97: 18.533, P999: 21.25 },
  { Month: 60, P01: 11.554, P3: 12.821, P50: 15.275, P97: 18.554, P999: 21.288 }
];

// ========== Boys Head Circumference 0-5 years (WHO HC-for-age, 5 percentile lines, sampled monthly) ==========
const BOYS_HC_0_5_RAW = [
  { Month: 0, P01: 30.536, P3: 32.073, P50: 34.462, P97: 36.851, P999: 38.387 },
  { Month: 1, P01: 33.635, P3: 35.048, P50: 37.244, P97: 39.439, P999: 40.852 },
  { Month: 2, P01: 35.51, P3: 36.929, P50: 39.135, P97: 41.341, P999: 42.759 },
  { Month: 3, P01: 36.849, P3: 38.278, P50: 40.501, P97: 42.724, P999: 44.153 },
  { Month: 4, P01: 37.95, P3: 39.394, P50: 41.64, P97: 43.886, P999: 45.331 },
  { Month: 5, P01: 38.822, P3: 40.282, P50: 42.552, P97: 44.823, P999: 46.283 },
  { Month: 6, P01: 39.567, P3: 41.043, P50: 43.339, P97: 45.636, P999: 47.112 },
  { Month: 7, P01: 40.168, P3: 41.66, P50: 43.979, P97: 46.298, P999: 47.79 },
  { Month: 8, P01: 40.69, P3: 42.196, P50: 44.538, P97: 46.881, P999: 48.387 },
  { Month: 9, P01: 41.118, P3: 42.638, P50: 45.001, P97: 47.364, P999: 48.883 },
  { Month: 10, P01: 41.486, P3: 43.018, P50: 45.4, P97: 47.783, P999: 49.315 },
  { Month: 11, P01: 41.815, P3: 43.359, P50: 45.759, P97: 48.16, P999: 49.703 },
  { Month: 12, P01: 42.094, P3: 43.647, P50: 46.064, P97: 48.48, P999: 50.034 },
  { Month: 13, P01: 42.348, P3: 43.911, P50: 46.342, P97: 48.773, P999: 50.336 },
  { Month: 14, P01: 42.566, P3: 44.138, P50: 46.583, P97: 49.029, P999: 50.601 },
  { Month: 15, P01: 42.77, P3: 44.351, P50: 46.809, P97: 49.267, P999: 50.848 },
  { Month: 16, P01: 42.949, P3: 44.538, P50: 47.009, P97: 49.48, P999: 51.069 },
  { Month: 17, P01: 43.114, P3: 44.711, P50: 47.194, P97: 49.676, P999: 51.273 },
  { Month: 18, P01: 43.273, P3: 44.877, P50: 47.372, P97: 49.867, P999: 51.471 },
  { Month: 19, P01: 43.417, P3: 45.028, P50: 47.534, P97: 50.04, P999: 51.651 },
  { Month: 20, P01: 43.558, P3: 45.176, P50: 47.693, P97: 50.21, P999: 51.829 },
  { Month: 21, P01: 43.686, P3: 45.312, P50: 47.84, P97: 50.368, P999: 51.994 },
  { Month: 22, P01: 43.812, P3: 45.445, P50: 47.985, P97: 50.525, P999: 52.158 },
  { Month: 23, P01: 43.931, P3: 45.57, P50: 48.12, P97: 50.669, P999: 52.309 },
  { Month: 24, P01: 44.043, P3: 45.689, P50: 48.249, P97: 50.809, P999: 52.456 },
  { Month: 25, P01: 44.155, P3: 45.808, P50: 48.378, P97: 50.948, P999: 52.601 },
  { Month: 26, P01: 44.256, P3: 45.916, P50: 48.497, P97: 51.079, P999: 52.739 },
  { Month: 27, P01: 44.358, P3: 46.024, P50: 48.616, P97: 51.207, P999: 52.873 },
  { Month: 28, P01: 44.452, P3: 46.125, P50: 48.726, P97: 51.326, P999: 52.999 },
  { Month: 29, P01: 44.544, P3: 46.223, P50: 48.834, P97: 51.445, P999: 53.124 },
  { Month: 30, P01: 44.629, P3: 46.314, P50: 48.935, P97: 51.555, P999: 53.24 },
  { Month: 31, P01: 44.714, P3: 46.405, P50: 49.034, P97: 51.663, P999: 53.354 },
  { Month: 32, P01: 44.792, P3: 46.488, P50: 49.126, P97: 51.764, P999: 53.46 },
  { Month: 33, P01: 44.866, P3: 46.568, P50: 49.214, P97: 51.86, P999: 53.562 },
  { Month: 34, P01: 44.939, P3: 46.646, P50: 49.301, P97: 51.956, P999: 53.663 },
  { Month: 35, P01: 45.007, P3: 46.719, P50: 49.382, P97: 52.045, P999: 53.757 },
  { Month: 36, P01: 45.074, P3: 46.791, P50: 49.462, P97: 52.133, P999: 53.85 },
  { Month: 37, P01: 45.135, P3: 46.858, P50: 49.536, P97: 52.215, P999: 53.937 },
  { Month: 38, P01: 45.198, P3: 46.925, P50: 49.61, P97: 52.295, P999: 54.022 },
  { Month: 39, P01: 45.255, P3: 46.986, P50: 49.679, P97: 52.372, P999: 54.103 },
  { Month: 40, P01: 45.311, P3: 47.047, P50: 49.748, P97: 52.448, P999: 54.184 },
  { Month: 41, P01: 45.365, P3: 47.105, P50: 49.812, P97: 52.518, P999: 54.259 },
  { Month: 42, P01: 45.415, P3: 47.16, P50: 49.874, P97: 52.587, P999: 54.332 },
  { Month: 43, P01: 45.467, P3: 47.216, P50: 49.936, P97: 52.656, P999: 54.405 },
  { Month: 44, P01: 45.515, P3: 47.268, P50: 49.994, P97: 52.72, P999: 54.473 },
  { Month: 45, P01: 45.562, P3: 47.319, P50: 50.052, P97: 52.785, P999: 54.542 },
  { Month: 46, P01: 45.607, P3: 47.368, P50: 50.106, P97: 52.845, P999: 54.606 },
  { Month: 47, P01: 45.651, P3: 47.416, P50: 50.161, P97: 52.905, P999: 54.67 },
  { Month: 48, P01: 45.693, P3: 47.461, P50: 50.212, P97: 52.962, P999: 54.73 },
  { Month: 49, P01: 45.733, P3: 47.505, P50: 50.261, P97: 53.017, P999: 54.789 },
  { Month: 50, P01: 45.774, P3: 47.55, P50: 50.311, P97: 53.072, P999: 54.847 },
  { Month: 51, P01: 45.812, P3: 47.591, P50: 50.357, P97: 53.124, P999: 54.903 },
  { Month: 52, P01: 45.85, P3: 47.632, P50: 50.404, P97: 53.176, P999: 54.959 },
  { Month: 53, P01: 45.885, P3: 47.671, P50: 50.449, P97: 53.226, P999: 55.012 },
  { Month: 54, P01: 45.921, P3: 47.711, P50: 50.493, P97: 53.276, P999: 55.065 },
  { Month: 55, P01: 45.957, P3: 47.749, P50: 50.535, P97: 53.322, P999: 55.114 },
  { Month: 56, P01: 45.989, P3: 47.785, P50: 50.577, P97: 53.368, P999: 55.164 },
  { Month: 57, P01: 46.023, P3: 47.821, P50: 50.618, P97: 53.415, P999: 55.214 },
  { Month: 58, P01: 46.056, P3: 47.857, P50: 50.658, P97: 53.459, P999: 55.261 },
  { Month: 59, P01: 46.088, P3: 47.892, P50: 50.699, P97: 53.505, P999: 55.309 },
  { Month: 60, P01: 46.12, P3: 47.927, P50: 50.737, P97: 53.548, P999: 55.355 }
];

// ========== Girls Head Circumference 0-5 years (WHO HC-for-age, 5 percentile lines, sampled monthly) ==========
const GIRLS_HC_0_5_RAW = [
  { Month: 0, P01: 30.219, P3: 31.651, P50: 33.879, P97: 36.106, P999: 37.539 },
  { Month: 1, P01: 32.893, P3: 34.311, P50: 36.516, P97: 38.722, P999: 40.14 },
  { Month: 2, P01: 34.513, P3: 35.978, P50: 38.258, P97: 40.538, P999: 42.003 },
  { Month: 3, P01: 35.686, P3: 37.187, P50: 39.521, P97: 41.855, P999: 43.356 },
  { Month: 4, P01: 36.677, P3: 38.208, P50: 40.59, P97: 42.971, P999: 44.502 },
  { Month: 5, P01: 37.48, P3: 39.035, P50: 41.454, P97: 43.873, P999: 45.428 },
  { Month: 6, P01: 38.181, P3: 39.757, P50: 42.208, P97: 44.658, P999: 46.234 },
  { Month: 7, P01: 38.758, P3: 40.351, P50: 42.828, P97: 45.305, P999: 46.897 },
  { Month: 8, P01: 39.27, P3: 40.877, P50: 43.375, P97: 45.874, P999: 47.481 },
  { Month: 9, P01: 39.696, P3: 41.314, P50: 43.831, P97: 46.348, P999: 47.966 },
  { Month: 10, P01: 40.067, P3: 41.695, P50: 44.227, P97: 46.759, P999: 48.388 },
  { Month: 11, P01: 40.405, P3: 42.041, P50: 44.587, P97: 47.132, P999: 48.768 },
  { Month: 12, P01: 40.695, P3: 42.338, P50: 44.894, P97: 47.45, P999: 49.093 },
  { Month: 13, P01: 40.963, P3: 42.613, P50: 45.178, P97: 47.743, P999: 49.393 },
  { Month: 14, P01: 41.197, P3: 42.852, P50: 45.426, P97: 47.999, P999: 49.654 },
  { Month: 15, P01: 41.418, P3: 43.078, P50: 45.658, P97: 48.239, P999: 49.898 },
  { Month: 16, P01: 41.614, P3: 43.278, P50: 45.865, P97: 48.452, P999: 50.116 },
  { Month: 17, P01: 41.797, P3: 43.464, P50: 46.057, P97: 48.65, P999: 50.317 },
  { Month: 18, P01: 41.975, P3: 43.645, P50: 46.243, P97: 48.841, P999: 50.512 },
  { Month: 19, P01: 42.136, P3: 43.81, P50: 46.414, P97: 49.017, P999: 50.691 },
  { Month: 20, P01: 42.296, P3: 43.973, P50: 46.581, P97: 49.19, P999: 50.867 },
  { Month: 21, P01: 42.445, P3: 44.125, P50: 46.738, P97: 49.35, P999: 51.03 },
  { Month: 22, P01: 42.594, P3: 44.276, P50: 46.893, P97: 49.51, P999: 51.193 },
  { Month: 23, P01: 42.733, P3: 44.418, P50: 47.039, P97: 49.659, P999: 51.344 },
  { Month: 24, P01: 42.867, P3: 44.555, P50: 47.18, P97: 49.805, P999: 51.493 },
  { Month: 25, P01: 43.002, P3: 44.693, P50: 47.321, P97: 49.949, P999: 51.639 },
  { Month: 26, P01: 43.128, P3: 44.82, P50: 47.452, P97: 50.084, P999: 51.776 },
  { Month: 27, P01: 43.252, P3: 44.947, P50: 47.583, P97: 50.218, P999: 51.913 },
  { Month: 28, P01: 43.368, P3: 45.065, P50: 47.704, P97: 50.342, P999: 52.039 },
  { Month: 29, P01: 43.483, P3: 45.181, P50: 47.823, P97: 50.465, P999: 52.164 },
  { Month: 30, P01: 43.589, P3: 45.289, P50: 47.934, P97: 50.578, P999: 52.278 },
  { Month: 31, P01: 43.694, P3: 45.396, P50: 48.043, P97: 50.689, P999: 52.391 },
  { Month: 32, P01: 43.79, P3: 45.494, P50: 48.143, P97: 50.793, P999: 52.496 },
  { Month: 33, P01: 43.884, P3: 45.588, P50: 48.24, P97: 50.891, P999: 52.595 },
  { Month: 34, P01: 43.975, P3: 45.681, P50: 48.335, P97: 50.988, P999: 52.695 },
  { Month: 35, P01: 44.06, P3: 45.767, P50: 48.423, P97: 51.079, P999: 52.786 },
  { Month: 36, P01: 44.145, P3: 45.854, P50: 48.511, P97: 51.167, P999: 52.876 },
  { Month: 37, P01: 44.224, P3: 45.934, P50: 48.592, P97: 51.251, P999: 52.96 },
  { Month: 38, P01: 44.302, P3: 46.013, P50: 48.673, P97: 51.333, P999: 53.044 },
  { Month: 39, P01: 44.375, P3: 46.087, P50: 48.749, P97: 51.41, P999: 53.122 },
  { Month: 40, P01: 44.449, P3: 46.161, P50: 48.824, P97: 51.487, P999: 53.199 },
  { Month: 41, P01: 44.517, P3: 46.23, P50: 48.894, P97: 51.558, P999: 53.271 },
  { Month: 42, P01: 44.583, P3: 46.297, P50: 48.962, P97: 51.627, P999: 53.341 },
  { Month: 43, P01: 44.65, P3: 46.364, P50: 49.03, P97: 51.696, P999: 53.41 },
  { Month: 44, P01: 44.712, P3: 46.427, P50: 49.093, P97: 51.76, P999: 53.475 },
  { Month: 45, P01: 44.773, P3: 46.488, P50: 49.157, P97: 51.825, P999: 53.541 },
  { Month: 46, P01: 44.831, P3: 46.548, P50: 49.216, P97: 51.885, P999: 53.601 },
  { Month: 47, P01: 44.89, P3: 46.607, P50: 49.276, P97: 51.945, P999: 53.661 },
  { Month: 48, P01: 44.945, P3: 46.662, P50: 49.332, P97: 52.002, P999: 53.72 },
  { Month: 49, P01: 44.999, P3: 46.716, P50: 49.387, P97: 52.057, P999: 53.775 },
  { Month: 50, P01: 45.053, P3: 46.77, P50: 49.442, P97: 52.114, P999: 53.832 },
  { Month: 51, P01: 45.105, P3: 46.823, P50: 49.494, P97: 52.166, P999: 53.884 },
  { Month: 52, P01: 45.156, P3: 46.874, P50: 49.547, P97: 52.219, P999: 53.938 },
  { Month: 53, P01: 45.204, P3: 46.923, P50: 49.597, P97: 52.27, P999: 53.989 },
  { Month: 54, P01: 45.255, P3: 46.974, P50: 49.647, P97: 52.32, P999: 54.039 },
  { Month: 55, P01: 45.301, P3: 47.021, P50: 49.695, P97: 52.369, P999: 54.088 },
  { Month: 56, P01: 45.347, P3: 47.067, P50: 49.741, P97: 52.416, P999: 54.136 },
  { Month: 57, P01: 45.394, P3: 47.114, P50: 49.789, P97: 52.463, P999: 54.183 },
  { Month: 58, P01: 45.438, P3: 47.159, P50: 49.834, P97: 52.508, P999: 54.229 },
  { Month: 59, P01: 45.483, P3: 47.204, P50: 49.879, P97: 52.555, P999: 54.275 },
  { Month: 60, P01: 45.526, P3: 47.247, P50: 49.923, P97: 52.598, P999: 54.319 }
];


export function getStandardGrowthCurves(gender, type, ageRange) {
  const isMale = (gender || '').toString().toLowerCase() === 'm';
  if (type === 'height') {
    // 0-5 chart: WHO data, 5 percentile lines (P0.1, P3, P50, P97, P99.9)
    // 5-18 chart: IAP 2015 data, 7 percentile lines (3rd, 10th, 25th, 50th, 75th, 90th, 97th)
    if (ageRange === '6-18') {
      const raw = isMale ? BOYS_HEIGHT_5_18_RAW : GIRLS_HEIGHT_5_18_RAW;
      return buildFromRawTable(raw);
    }
    const raw = isMale ? BOYS_HEIGHT_0_5_RAW : GIRLS_HEIGHT_0_5_RAW;
    return buildFromRawTable5WHO(raw);
  }
  if (type === 'weight') {
    // 0-5 chart: WHO data, 5 percentile lines
    // 5-18 chart: IAP 2015 data, 7 percentile lines
    if (ageRange === '6-18') {
      const raw = isMale ? BOYS_WEIGHT_5_18_RAW : GIRLS_WEIGHT_5_18_RAW;
      return buildFromRawTable(raw);
    }
    const raw = isMale ? BOYS_WEIGHT_0_5_RAW : GIRLS_WEIGHT_0_5_RAW;
    return buildFromRawTable5WHO(raw);
  }
  if (type === 'bmi') {
    // BMI is 0-5 only: WHO data, 5 percentile lines (P0.1, P3, P50, P97, P99.9)
    const raw = isMale ? BOYS_BMI_0_5_RAW : GIRLS_BMI_0_5_RAW;
    return buildFromRawTable5WHO(raw);
  }
  if (type === 'head circumference') {
    // Head Circumference is 0-5 only: WHO data, 5 percentile lines (P0.1, P3, P50, P97, P99.9)
    const raw = isMale ? BOYS_HC_0_5_RAW : GIRLS_HC_0_5_RAW;
    return buildFromRawTable5WHO(raw);
  }
  return { ages: [], curves: [] };
}
